/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button } from '@mui/material';
import DatePicker from 'react-datepicker';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import React, { ReactNode } from 'react';
import TabLinks from '../../../components/TabLinks/TabLinks';

interface PropsFirstLine {
  tabValues: { name: string; value: string; active: boolean }[];
  handleTab: (e: any) => void;
  handleDropdown: (e: any) => void;
  reportExpiry?: Date;
  /** Location dropdown, shown inline after the chart-type select. */
  filterSlot?: ReactNode;
  /** Tag pill row, shown on its own line under a divider. */
  tagSlot?: ReactNode;
  /** Right-aligned buttons (Export CSV / Download report). */
  actions?: ReactNode;
}

export default function FirstLine({
  tabValues,
  handleTab,
  handleDropdown,
  reportExpiry,
  filterSlot,
  tagSlot,
  actions,
}: PropsFirstLine) {
  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        border: '1px solid #e6eaeb',
        borderRadius: '12px',
        padding: '14px 18px 12px',
        marginBottom: '14px',
      }}
    >
      <Box sx={{ display: 'flex', marginBottom: '12px' }}>
        <TabLinks data={tabValues} func={handleTab} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '14px',
        }}
      >
        <select
          name="options"
          id="options"
          className="chart-type-select"
          onChange={(e) => handleDropdown(e.target.value)}
        >
          <option value="activityChart">Activity chart</option>
          <option value="timeSeriesChart">Time series chart</option>
        </select>

        {filterSlot}

        {reportExpiry && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Button
              sx={{ color: 'rgb(100, 100, 100)' }}
              size="large"
              startIcon={<CalendarTodayIcon className="start-icons" />}
            >
              Report expiry
            </Button>
            <span>
              <DatePicker
                disabled
                selected={new Date(reportExpiry)}
                dateFormat="dd/MM/yyyy"
                // eslint-disable-next-line no-console
                onChange={() => console.log('Not allowed to change')}
                className="w-100 outline-0 cursor-pointer"
              />
            </span>
          </Box>
        )}

        {actions && (
          <Box
            sx={{
              marginLeft: 'auto',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
            }}
          >
            {actions}
          </Box>
        )}
      </Box>

      {tagSlot && (
        <Box sx={{ borderTop: '1px solid #e6eaeb', marginTop: '12px', paddingTop: '12px' }}>
          {tagSlot}
        </Box>
      )}
    </Box>
  );
}
